import axios from 'axios'
import { Message } from 'element-ui'
// import Vue from 'vue'
import { showLoading, hideLoading } from '../assets/js/loading.js';
import store from '../store';
import { aes } from "./crypto.js";
// import { getToken, TokenKey } from '@/utils/auth'
// const Base64 = require('js-base64').Base64
// create an axios instance
const service = axios.create({
    timeout: 200000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8;',
    },
    withCredentials: true
})

service.interceptors.request.use(config => {
    // showLoading();
    if (store.getters.token) {
        config.headers["Authorization"] = `Bearer ${store.getters.token}`;
    }
    if (config.params) {
        if (config.aes) {
            config.data = {encrypt: aes.en(JSON.stringify(config.params))};        
        } else {
            config.data = JSON.stringify(config.params);
        }
    }
    return config
}, error => {
    Promise.reject(error)
})
service.interceptors.response.use(
    response => {
        // hideLoading();
        const res = response.data;
        if (res.code == 403) {
            Message.closeAll()
            // Message({
            //     message: 'Session expired',
            //     type: 'error',
            //     duration: 5 * 1000
            // });
            
            store.commit("SESSION_EXPIRED", true);
            return Promise.reject('error');
        }
        return response
    },
    error => {
        Message({
            message: error + '',
            type: 'error',
            duration: 5 * 1000
        })
        hideLoading();
        return Promise.reject(error)
    }
)
export default service


// WEBPACK FOOTER //
// ./src/api/requests.js